 /**
 * index
 * @param _$target {HTMLElement}
 * @param _$$group {HTMLElement}
 * @return {integer} index
 */
module.exports = (() => {
  return {
    getIndex: (_$target, _$$group) => {
      for(var i_ = 0; _$$group.length > i_; i_++) {
        if(_$$group[i_] === _$target) {
          return i_;
          break;
        }
      }
    },
  }
})();



/** WEBPACK FOOTER **
 ** ./webpack/requires/view/module/index.js
 **/